/**
 * <Skeleton /> — Obsidian-flavored loading placeholder. Uses the design tokens.
 * `w` and `h` are Tailwind sizing units. Set `rounded` if the shape needs a
 * different corner.
 */
export function Skeleton({ className = "", ...rest }) {
  return (
    <div
      className={`animate-pulse rounded-md bg-hm-bg-1 border border-hm-border/40 ${className}`}
      {...rest}
    />
  );
}

export function SkeletonRow({ cols = 4 }) {
  return (
    <div className="hm-surface p-4 flex items-center gap-4" data-testid="skeleton-row">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} className={`h-4 ${i === 0 ? "w-32" : "flex-1"}`} />
      ))}
    </div>
  );
}

export function SkeletonList({ n = 6, cols = 4 }) {
  return (
    <div className="space-y-2" data-testid="skeleton-list">
      {Array.from({ length: n }).map((_, i) => (
        <SkeletonRow key={i} cols={cols} />
      ))}
    </div>
  );
}
